import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { StudentService } from 'src/app/services/http/business/student/student.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';

@Component({
  selector: 'app-submit-survey',
  templateUrl: './submit-survey.component.html',
  styleUrls: ['./submit-survey.component.css']
})
export class SubmitSurveyComponent implements OnInit {
  questions = [];
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  progressValue=0;
  errObject: any;
  param: any;
  errors: any;
  public model={
    questions:[]
  }
  public total=0;
  constructor(
    public translate: TranslateService,
    private errorService: ErrorsService,
    private snackBar: SnackBarService,
    private studentService: StudentService,
    private dialog: MatDialogRef<SubmitSurveyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.refresh();
  }

  refresh() {
    this.studentService.getQuestionList(this.data).subscribe(res => {
      this.total=res.Total;
      this.questions = res.DataList;
    });
  }
   settingChart(){
    this.progressValue = (this.model.questions.length * 100) / this.total;
   }
  addAnswerSelected(question:any,item: any) {
   let tepm=this.model.questions.find(x=>x.QuestionId == question.Id);
   if (tepm) {
     this.model.questions.splice(tepm, 1);
   }
  //  else{
  //     this.settingChart();
  //  }
   this.model.questions.push({"RegisterId": this.data.Id,"AnswerId": item.Id,"QuestionId": question.Id});
   this.settingChart();
  }
  setColorProgress(){
    if (this.model.questions.length == this.total) {
      return "primary"
    }else if ((this.total / 2) <= this.model.questions.length && 
    this.total > this.model.questions.length) {
      return "warn"
    } else {
      return "accent"
    }
  }
  submit() {
   
      if (this.model.questions.length == this.total) {
        this.studentService.surveyListAdd(this.model.questions).subscribe(
          () => {
            this.snackBar.OpenSnackBar(
              this.translate.get("success.registration"),
              "ok",
              5000,
              SoundEnum.beep
            );
            this.onNoClick();
          },
          error => {
            this.errObject = this.errorService.getError(error);
            this.param = this.errorService.objectError(this.errObject);
            this.errors = this.errorService.returnError(error);
          }
        );
      } else {
        this.snackBar.OpenSnackBar(
          this.translate.get("لطفا قبل از ثبت تمامی سوالات را پاسخ دهید ."),
          "ok",
          5000,
          SoundEnum.beep
        );
      }

  }
  onNoClick() {
    this.dialog.close();
  }
}
